// @ts-strict-ignore
import { AxiosError } from 'axios';
import ReactHotToast from 'react-hot-toast';

import { Button } from '@/components/Button/Button';
import { useFollowPublicSource } from '@/components/ConnectApps/Common/useFollowPublicSource';
import { useIsSourceConnected } from '@/components/SourceCards/hooks/useIsSourceConnected';
import { getAppGroupTitle } from '@/utils/getAppTitle';
import { SourceFollowToast } from '@/utils/toasts';

export const FollowButton = ({ sourceId, label }: FollowType) => {
  const followMutation = useFollowPublicSource();

  const { isConnected, isLoading } = useIsSourceConnected(sourceId);

  const followPublicSource = () => {
    followMutation.mutate(
      { key: sourceId, label },
      {
        onSuccess: () => {
          const groupTitle = getAppGroupTitle(sourceId);
          SourceFollowToast(groupTitle || label);
        },
        onError: (error: unknown) => {
          if (error instanceof AxiosError) {
            const errorMessage =
              error?.response?.data?.error ||
              'Something went wrong. Please try again';
            ReactHotToast.error(errorMessage);
          }
        },
      }
    );
  };

  if (isConnected || isLoading) {
    return null;
  }

  return (
    <Button
      className='flex-shrink-0'
      variant='success'
      size='extrasmall'
      label='Follow'
      loading={followMutation.isLoading}
      onClick={followPublicSource}
    />
  );
};

type FollowType = {
  sourceId: string;
  label?: string;
};
